import React from 'react';
import { formatSessionTimestamp } from '../../utils/recordingForm';

const SessionMetadataBar = ({
  caseReference,
  language,
  courtName,
  initiatorName,
  startedAt,
  status,
}) => (
  <div className="rounded-lg border border-legal-200 bg-legal-50 p-3 text-xs sm:text-sm space-y-2">
    <div className="flex flex-wrap gap-x-4 gap-y-1 text-legal-700">
      <span>
        <span className="font-medium text-legal-900">Case:</span> {caseReference || '—'}
      </span>
      <span>
        <span className="font-medium text-legal-900">Language:</span> {language || '—'}
      </span>
      <span>
        <span className="font-medium text-legal-900">Court:</span> {courtName || '—'}
      </span>
    </div>
    <div className="flex flex-wrap gap-x-4 gap-y-1 text-legal-600">
      <span>
        <span className="font-medium text-legal-800">Initiated by:</span> {initiatorName || '—'}
      </span>
      <span>
        <span className="font-medium text-legal-800">Started:</span>{' '}
        {formatSessionTimestamp(startedAt)}
      </span>
      {status && (
        <span>
          <span className="font-medium text-legal-800">Status:</span> {status}
        </span>
      )}
    </div>
  </div>
);

export default SessionMetadataBar;
